import styled, { css } from 'styled-components';
import { NumberPlatePreviewSize } from './NumberPlatePreview.model';

const StyledContainer = styled.div<{
	$dark?: boolean;
	$size: NumberPlatePreviewSize;
}>`
	display: flex;
	width: ${({ $size }) =>
		$size === NumberPlatePreviewSize.Size20 ? '80px' : '110px'};
	height: ${({ $size }) =>
		$size === NumberPlatePreviewSize.Size20 ? '20px' : '30px'};
	${({ $size }) =>
		$size === NumberPlatePreviewSize.Size20 &&
		css`
			align-items: center;
			justify-content: center;
			gap: 4px;
		`}

	background-color: ${({ $dark }) =>
		$dark ? 'rgba(255, 255, 255, 0.1)' : '#FFFFFF'};
	color: ${({ $dark }) => ($dark ? '#ffffff' : '#000000')};
	transition:
		background-color 0.3s ease,
		color 0.3s ease;
	border-radius: ${({ $size }) =>
		$size === NumberPlatePreviewSize.Size20 ? '6px' : '5px'};
	text-transform: uppercase;

	${({ $dark }) =>
		!$dark &&
		css`
			border: 1px solid rgba(0, 0, 0, 0.25);
		`}
`;

const StyledNumberContainer = styled.div<{
	$dark?: boolean;
}>`
	display: flex;
	align-items: flex-end;
	justify-content: center;
	width: 80px;
	padding: 6px 11px 6px 12px;
	border-right: 1px solid
		${({ $dark }) =>
			$dark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
	transition: border-color 0.3s ease;

	span {
		font-family: 'GT Walsheim Pro';
		font-weight: 500;
		letter-spacing: 0.45px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCustomNumberContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;

	span {
		font-family: 'GT Walsheim Pro';
		font-weight: 500;
		letter-spacing: 0.45px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledPlateNumber = styled.span`
	font-size: 16px;
	line-height: 18px;
`;

const StyledPlateLetter = styled.span`
	font-size: 12px;
	line-height: 16px;
	text-transform: uppercase;
`;

const StyledRegionContainer = styled.div`
	position: relative;
	width: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	user-select: none;
	pointer-events: none;
	font-family: 'GT Walsheim Pro';

	span:first-child {
		font-size: 10px;
		font-weight: bold;
		line-height: 11px;
		margin-bottom: 2px;
	}

	span:last-child {
		font-size: 8px;
		font-weight: 500;
		line-height: 9px;
		opacity: 0.5;
	}
`;

const StyledDivider = styled.div<{ $dark?: boolean }>`
	width: 1px;
	min-width: 1px;
	height: ${({ $dark }) => ($dark ? '20px' : '18px')};
	background-color: ${({ $dark }) =>
		$dark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
`;

export {
	StyledContainer,
	StyledCustomNumberContainer,
	StyledDivider,
	StyledNumberContainer,
	StyledPlateLetter,
	StyledPlateNumber,
	StyledRegionContainer,
};
